module.exports = __webpack_public_path__ + "img/human_vue.1054b8d1.jpeg";